import { DialogMessageType } from "@/types/commands";

// Socket.IO contract (matches server in slideGenerationService.ts)
export const SLIDE_GENERATION_PROGRESS_EVENT = "slideGenerationProgress";
export const JOIN_SLIDE_GENERATION_ROOM_EVENT = "joinSlideGenerationRoom";

export function slideGenerationRoomName(jobId: string): string {
  return `slide_generation_${jobId}`;
}

// LocalStorage keys
export const LS_KEY_CONTENT_READY_MODE = "contentReadyMode";
export const LS_KEY_ACTIVE_SLIDES_JOB_IDS = "activeSlidesJobIds";
export const LS_KEY_ACTIVE_SLIDES_FRAME_BY_JOB = "activeSlidesFrameByJob";

export type ContentReadyMode = "charts" | "slides";

// Dialog (ContentSlide) → parent taskpane (placeholderSelection.handleMessage).
export interface OpenContentReadySlidesMessage {
  type: DialogMessageType.OPEN_CONTENT_READY_SLIDES;
  jobId: string;
  slideFrameId?: number;
}

// Parent taskpane → in-window listeners (App, SlidesContentReady).
export interface SlidesContentReadyWindowMessage {
  type: "SLIDES_CONTENT_READY";
  jobId?: string;
}

// SlidesContentReady → App and other listeners after job set changes.
export interface SlidesJobsChangedWindowMessage {
  type: "SLIDES_JOBS_CHANGED";
}

// Progress snapshot shape (mirror of server SlideGenerationProgressSnapshot)
export type SlidesProgressPhase =
  | "queued"
  | "llm_pipeline"
  | "chart_extraction"
  | "powerpoint_assembly"
  | "completed"
  | "failed";

export interface SlidesProgressSnapshot {
  jobId: string;
  status: string;
  progressPercent: number;
  phase: SlidesProgressPhase;
  step: string;
  totalCharts: number;
  completedCharts: number;
}
